import { render } from "./PotentialAnalysisV1.vue?vue&type=template&id=329181b6&scoped=true&lang=pug"
import script from "./PotentialAnalysisV1.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialAnalysisV1.vue?vue&type=script&setup=true&lang=js"

import "./PotentialAnalysisV1.vue?vue&type=style&index=0&id=329181b6&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329181b6"]])

export default __exports__